import { useIsFetching, useIsMutating } from "@tanstack/react-query"

import LoadingStyles from "./loading.module.css"
import React from "react"
import classNames from "classnames"
import { useAuthState } from "../../context/auth"
import { useDelayedUnmounting } from "../../hooks/use-delayed-unmounting"
import { useIsSSR } from "../../hooks/use-is-ssr"
import { useLoadingState } from "../../context/loading"
import { useLocalesState } from "../../context/locales"

type LoadingProps = {
    disableReAuth?: boolean
    disableSSR?: boolean
    loading?: boolean
    blur?: boolean
}

const Loading = ({ disableReAuth, disableSSR, loading, blur = true }: LoadingProps) => {
    const { loading: authLoading, reAuthLoading } = useAuthState()
    const { loading: localesLoading } = useLocalesState()
    const { loading: manualLoading } = useLoadingState()
    const isMutating = useIsMutating()
    const isFetching = useIsFetching({ stale: false, predicate: ({ meta }) => !meta?.background })
    const isSSR = useIsSSR()

    const shouldRender = useDelayedUnmounting(
        authLoading ||
            localesLoading ||
            manualLoading ||
            isFetching ||
            isMutating ||
            (!disableReAuth && reAuthLoading) ||
            (!disableSSR && isSSR) ||
            loading
    )

    if (!shouldRender && !(!disableSSR && isSSR)) return null

    return (
        <section className={classNames(LoadingStyles.container, { [LoadingStyles.blur]: blur })}>
            <div className={LoadingStyles.spinner} />
        </section>
    )
}

export default Loading
